<template>
    <div>
        <div class="boolean">
            <div
                :class="{ 'boolean__switch': true, 'boolean__switch--on': value }"
                @click="toggle"
            >
                <div class="boolean__toggle" />
                <input
                    type="hidden"
                    :name="name"
                    :value="value ? 1 : 0"
                >
            </div>
            <label>{{ label }}</label>
        </div>
    </div>
</template>
<script>
export default {
    props: ['name', 'initialValue', 'label'],
    data() {
        return {
            value: false,
        };
    },
    mounted() {
        this.value = this.initialValue;
    },
    methods: {
        toggle() {
            this.value = !this.value;
            this.$emit('input', this.value);
        },
    },

};
</script>
